import type { IRateIndex } from 'components/RateIndexes'
import { useState } from 'react'
import { addRateIndex, updateRateIndex } from 'services'
import { Modal } from 'stories/components'

/** Add or edit one of the customer's own indexes. Standard indexes are not edited here. */
export const RateIndexModal = ({
  index,
  onClose,
}: {
  index: IRateIndex | null
  onClose: (changed: boolean) => void
}) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [values, setValues] = useState({
    name: index?.name || '',
    source: index?.source || '',
    description: index?.description || '',
  })

  const set = (key: string, value: string) => setValues((prev) => ({ ...prev, [key]: value }))

  const onSubmit = async () => {
    setError('')
    if (!values.name.trim()) {
      setError('Index name is required')
      return
    }
    setLoading(true)
    try {
      if (index) await updateRateIndex(index.key, values)
      else await addRateIndex(values)
      onClose(true)
    } catch (err: any) {
      setError(err?.message || 'Could not save the index')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={index ? `Update Index - ${index.name}` : 'Add Rate Index'}
      titleOkay="Save"
      loading={loading}
      onClose={() => onClose(false)}
      onOk={onSubmit}
      isOpen
    >
      <div className="text-gray-900 w-144 grid grid-cols-2 gap-4 mb-3 mt-2">
        <div className="col-span-2">
          <div className="text-[13px] text-gray-500 mb-1">Index Name</div>
          <input
            className="text-[14px] border rounded px-2 py-2 w-full"
            value={values.name}
            placeholder="e.g. Cost of Funds"
            onChange={(e) => set('name', e.target.value)}
          />
        </div>
        <div className="col-span-2">
          <div className="text-[13px] text-gray-500 mb-1">Source</div>
          <input
            className="text-[14px] border rounded px-2 py-2 w-full"
            value={values.source}
            placeholder="Who publishes it"
            onChange={(e) => set('source', e.target.value)}
          />
        </div>
        <div className="col-span-2">
          <div className="text-[13px] text-gray-500 mb-1">Description</div>
          <textarea
            className="text-[14px] border rounded px-2 py-2 w-full"
            rows={3}
            value={values.description}
            onChange={(e) => set('description', e.target.value)}
          />
        </div>
        {error && <div className="col-span-2 text-sm text-red-700">{error}</div>}
      </div>
    </Modal>
  )
}
